import React from 'react';
import { observer } from 'mobx-react';

import ToastMessage from './ToastMessage';
import { useToastStore } from './ToastStore';

function ToastContainer() {
  const toastStore = useToastStore();

  const onClose = (id: string) => {
    toastStore.removeToast(id);
  };

  const toasts = toastStore.toasts;
  return toasts.length ? (
    <div className="pointer-events-none fixed inset-0 flex flex-col items-end justify-start px-4 py-6 sm:p-6">
      {toasts.map((reducedToast) => (
        <ToastMessage
          key={reducedToast.toast.id}
          reducedToast={reducedToast}
          onClose={() => onClose(reducedToast.toast.id)}
        />
      ))}
    </div>
  ) : null;
}

export default observer(ToastContainer);
